import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreditSafeReportRelatedPersonSchema = z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    address: z.string().optional(),
    gender: z.string().optional(),
    positions: z.string().optional(),
});

export class CreditSafeReportRelatedPerson extends FromSchema(CreditSafeReportRelatedPersonSchema) {
    firstName?: string;
    lastName?: string;
    address?: string;
    gender?: string;
    positions?: string;
}
